import { Box, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useShouldUseNewStripeOnboarding } from "@src/appV2/Stripe/useShouldUseNewStripeOnboarding";
import { useHistory } from "react-router-dom";

import { STRIPE_ONBOARDING_FULL_PATH } from "../paths";
import { SetUpStripeAccountBanner } from "./SetUpStripeAccountBanner";

export interface SetUpStripeAccountBannerContainerProps {
  sourceUI: "account-tab" | "shifts-tab";
  sx?: SxProps<Theme>;
}

export function SetUpStripeAccountBannerContainer(props: SetUpStripeAccountBannerContainerProps) {
  const { sourceUI, sx } = props;

  const history = useHistory();
  const isBannerShown = useShouldUseNewStripeOnboarding();

  useLogEffect(
    APP_V2_USER_EVENTS.PAYMENTS_ONBOARDING_SET_UP_BANNER_SHOWN,
    {
      sourceUI,
    },
    { enabled: isBannerShown }
  );

  if (!isBannerShown) {
    return null;
  }

  return (
    <Box sx={sx}>
      <SetUpStripeAccountBanner
        onSetUpStripeAccountClick={() => {
          logEvent(APP_V2_USER_EVENTS.PAYMENTS_ONBOARDING_ENTRYPOINT_CLICKED, {
            sourceUI,
          });
          history.push(STRIPE_ONBOARDING_FULL_PATH);
        }}
      />
    </Box>
  );
}
